import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import EmptyData from 'components/global/EmptyData'
import EmailTemplateModal from 'pages/Events/Views/Common/Modals/EmailTemplateModal'
import React, { useState } from 'react'
import { leagueEventStore } from 'state/league/leagueEvent'
import TemplateInfoLeague from './TemplateInfoLeague'
import { useUpdateEmailTemplateForEvent } from 'api/EmailTemplates/EmailTemplates'
import { FinalEventEmailTemplatePayload } from 'types/event/eventStep5'

interface AddTemplateToLeagueProps {
  openModal: boolean
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>
}

const AddTemplateToLeague: React.FC<AddTemplateToLeagueProps> = ({
  openModal,
  setOpenModal,
}) => {
  const [addTemplateModal, setAddTemplateModal] = useState<boolean>(false)
  const [loaderId, setLoaderId] = useState<string | null>(null)
  const [templateData, setTemplateData] = useState<any | undefined>()
  const { mutate: updateTemplate } = useUpdateEmailTemplateForEvent()
  const { leagueData, setLeagueData } = leagueEventStore(store => ({
    leagueData: store.leagueData,
    setLeagueData: store.setLeagueData,
  }))
  const handleCloseModal = () => {
    setOpenModal(false)
  }

  const handleAddTemplate = () => {
    setAddTemplateModal(true)
  }

  const handleAddToEvent = (
    templateId: string,
    operation: 'add' | 'remove',
  ) => {
    setLoaderId(templateId)
    const payload: FinalEventEmailTemplatePayload = {
      emailTemplate: {
        ...templateData,
        status: operation === 'add' ? 'active' : 'draft',
      },
    }
    updateTemplate(
      {
        payload,
        referenceId: leagueData._id,
        templateId: templateId,
        reference: 'league',
      },
      {
        onSuccess: data => {
          setLeagueData({ ...leagueData, ...data })
          setLoaderId(null)
        },
        onError: () => {
          setLoaderId(null)
        },
      },
    )
  }

  const handleEditTemplate = (emailTemplate: any) => {
    setTemplateData(emailTemplate)
    setAddTemplateModal(true)
  }

  return (
    <>
      <CustomModal
        openModal={openModal}
        isCloseModalCustom={true}
        closeModal={handleCloseModal}
        width={700}
        title="Add Template to League"
        footer={
          <CustomModalFooter
            multibutton={true}
            btnAlignment="justify-between"
            btnText="Cancel,Add new template"
            closeModal={handleCloseModal}
            onSubmit={handleAddTemplate}
          />
        }
      >
        <p>Set the email template and the trigger when it should be sent.</p>
        {leagueData?.emailTemplates.length > 0 ? (
          <div>
            {leagueData?.emailTemplates.map(template => {
              return (
                <div key={template._id}>
                  <TemplateInfoLeague
                    template={template}
                    loaderId={loaderId}
                    isEventTemplate
                    handleAddToEvent={handleAddToEvent}
                    handleEditTemplate={handleEditTemplate}
                  />
                </div>
              )
            })}
          </div>
        ) : (
          <div className="h-full flex align-center justify-center">
            <EmptyData message="No templates available" />
          </div>
        )}
      </CustomModal>

      {addTemplateModal && (
        <EmailTemplateModal
          openModal={addTemplateModal}
          closeModal={setAddTemplateModal}
          organizationId={leagueData.organizationId}
          referenceId={leagueData._id}
          reference="league"
          data={templateData}
        />
      )}
    </>
  )
}

export default AddTemplateToLeague
